export default "__VITE_ASSET__CnhAO4yi__"